'use strict';

/**
 * @author Maxim Seredkin
 */

import angular from 'angular';

export default ['$scope', '$uibModalInstance', 'ownershipForm', 'ownershipFormFilters', 'def',
                function($scope, $modalInstance, ownershipForm, ownershipFormFilters, def) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.isSelect = isSelect;

                    init();

                    // region Function

                    function init() {
                        // инициализация модели
                        $scope.ownershipForm = angular.copy(ownershipForm);
                        $scope.filters = angular.copy(ownershipFormFilters);
                        $scope.def = angular.copy(def);
                    }

                    function ok(ownershipForm) {
                        $modalInstance.close(ownershipForm);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    function isSelect() {
                        return $scope.ownershipForm != null && $scope.ownershipForm.id != null;
                    }

                    // endregion
                }];
